<template>
  <div class="product-container">
    <nav class="container-wrapper">
        <div class="row w-auto my-3">
          <div class="col-12 mb-3">
            <span class="filter_by">Filter by:</span>
          </div>
          <div class="col-xl-3 col-md-4 col-12 my-2">
            <primary-select
                    type="text"
                    class="company"
                    v-model="selectedCompany"
                    placeholder="Select Company"
            >
              <option
                      v-for="company in companies"
                      :key="company.value"
                      :value="company.value"
              >
                {{ company.name }}
              </option>
            </primary-select>
          </div>
          <div class="col-xl-3 col-md-4 col-12 my-2">
            <primary-select
                    type="text"
                    class="company"
                    v-model="selectedReseller"
                    placeholder="Select Reseller"
            >
              <option
                      v-for="reseller in resellers"
                      :key="reseller.value"
                      :value="reseller.value"
              >
                {{ reseller.name }}
              </option>
            </primary-select>
          </div>
          <div class="col-xl-3 col-md-4 col-12 my-2">
            <primary-select
                    type="text"
                    class="choose-company"
                    v-model="prepay"
                    placeholder="Select Plan"
            >
              <option
                      v-for="type in paymentTypes"
                      :value="type.value"
                      :key="type.name"
              >
                {{ type.name }}
              </option>
            </primary-select>
          </div>
          <div class="col-md-auto col-12 d-flex flex-wrap">
            <div class="reset-button my-2 mr-4">
              <primary-button @click.native="reasetFilters">Reset</primary-button>
            </div>
            <div class="show-active-items my-2">
              <input
                      type="checkbox"
                      id="show-active"
                      class="active-checkbox"
                      v-model="isActive"
              />
              <label for="show-active">Active Only</label>
            </div>
          </div>
          <div class="col-12 d-flex justify-content-md-end flex-wrap buttons-wrapper">
            <div class="primary-button my-2 white_space" style="width: 200px; margin-right: 15px">
              <primary-button
                      @click.native="
              $router.push({ name: 'system-admin-add-manual-payment' })
            "
              >Add Manual Payment</primary-button
              >
            </div>
            <div class="primary-button my-2">
              <primary-button
                      @click.native="$router.push({ name: 'system-admin-add-company' })"
              >Add Company</primary-button
              >
            </div>
          </div>
      </div>
    </nav>

    <loader :loading="loading" v-if="loading" />
    <template v-else>
      <not-found v-if="isFound" />
      <div
        v-else
        class="table_div"
        style="width: 100%; overflow-x: auto; overflow-y: hidden"
      >
        <table class="Invoice_table">
          <thead>
            <tr class="Invoice_table_header">
              <th class="company-name">Company Name</th>
              <th class="balance">Balance</th>
              <th class="postpay">Postpay Credit</th>
              <th class="contact">Credit</th>
              <th class="product">Product</th>
              <th class="reseller">Resellers</th>
              <th class="email">Email</th>
              <th class="created-on">Created On</th>
              <th style="width: 200px; padding-left: 0; padding-right: 0">
                Action
              </th>
            </tr>
          </thead>
          <tbody v-if="allcompanies.length > 0">
            <tr
              class="line"
              v-for="(company, k) in allcompanies"
              :key="k"
              :class="{
                active: company.isActive === true,
                inactive: company.isActive === false,
              }"
            >
              <th class="company-name">
                <div class="img-container">
                  <div class="status" @click="changeStatus(company)"></div>
                  <span :title="company.companyName">{{
                    company.companyName
                  }}</span>
                </div>
              </th>
              <th>${{ company.balance }}</th>
              <th class="postpay">
                {{ company.prepay ? "Postpaid" : "Prepaid" }}
              </th>
              <th class="smsText">{{ company.credit }}</th>
              <th class="products">{{ company.productName }}</th>
              <th class="reseller">{{ company.resaller }}</th>
              <th class="email">{{ company.email }}</th>
              <th class="created-on">
                {{ company.created_on }}
              </th>
              <th
                style="width: 200px; padding-left: 0; padding-right: 0"
                class="icon"
              >
                <svg
                  @click="
                    $router.push({
                      name: 'system-admin-edit-company',
                      params: { id: company.companyId },
                    })
                  "
                  class="svg-grey edit"
                  width="30px"
                  height="30px"
                  viewBox="0 0 30 30"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <title>Edit</title>
                  <path
                    d="M21.0636684,5 L16.5223005,5 C16.0222902,5 15.6155648,5.41380074 15.6155648,5.92250923 L15.6155648,19.7548339 C15.6155648,20.0601476 15.7303938,20.4698893 15.8885285,20.7291513 L18.1395544,24.4204428 C18.2910881,24.6688561 18.5293057,24.8114391 18.793057,24.8114391 C19.0568083,24.8114391 19.2949534,24.6688561 19.4465596,24.420369 L21.6974404,20.7292251 C21.8556477,20.4698155 21.9704767,20.0601476 21.9704767,19.7548339 L21.9704767,5.92250923 C21.9704041,5.41380074 21.5636062,5 21.0636684,5 Z M19.1930363,22.7361624 L18.3929326,22.7361624 L17.1373575,20.6773432 L20.4485389,20.6773432 L19.1930363,22.7361624 Z M16.7035751,19.5703321 L16.7035751,8.61188192 L18.2488705,8.61188192 L18.2488705,19.5703321 L16.7035751,19.5703321 Z M19.3370259,19.5703321 L19.3370259,8.61188192 L20.8823212,8.61188192 L20.8823212,19.5703321 L19.3370259,19.5703321 Z M20.8823212,6.10701107 L20.8823212,7.50487085 L16.7036477,7.50487085 L16.7036477,6.10701107 L20.8823212,6.10701107 Z M16.4717409,23.8886347 C16.7721969,23.8886347 17.0157824,24.1364576 17.0157824,24.4421402 C17.0157824,24.7478229 16.7721969,24.9956458 16.4717409,24.9956458 L8.56943005,24.9956458 C8.26897409,24.9956458 8.0253886,24.7478229 8.0253886,24.4421402 C8.0253886,24.1363838 8.26897409,23.8886347 8.56943005,23.8886347 L16.4717409,23.8886347 Z"
                    id="path-1"
                  />
                </svg>
                <svg
                  @click="deleteCompany(company.companyId)"
                  class="svg-grey delete"
                  width="30px"
                  height="30px"
                  viewBox="0 0 30 30"
                  version="1.1"
                >
                  <title>Delete</title>
                  <path
                    d="M22.0359259,7.63839416 L18.7919259,7.63839416 L18.7919259,6.35036496 C18.7919259,5.60576642 18.1771852,5 17.4215556,5 L12.5477037,5 C11.7920741,5 11.1773333,5.60576642 11.1773333,6.35036496 L11.1773333,7.63839416 L7.93333333,7.63839416 C7.42274074,7.63839416 7.00740741,8.04766423 7.00740741,8.55080292 L7.00740741,10.2229927 C7.00740741,10.7261314 7.42274074,11.1354015 7.93333333,11.1354015 L8.47111111,11.1354015 L8.47111111,23.6922628 C8.47111111,24.3966423 9.05266667,24.969635 9.76740741,24.969635 L20.2017778,24.969635 C20.9165185,24.969635 21.4980741,24.3966423 21.4980741,23.6922628 L21.4980741,11.1354745 L22.0359259,11.1354745 C22.5465185,11.1354745 22.9618519,10.7262044 22.9618519,10.2230657 L22.9618519,8.55080292 C22.9618519,8.04773723 22.5464444,7.63839416 22.0359259,7.63839416 Z M12.2884444,6.35036496 C12.2884444,6.21189781 12.4071852,6.09489051 12.5477037,6.09489051 L17.4215556,6.09489051 C17.5620741,6.09489051 17.6808148,6.21189781 17.6808148,6.35036496 L17.6808148,7.63839416 L12.2884444,7.63839416 L12.2884444,6.35036496 Z M20.386963,23.6923358 C20.386963,23.7912409 20.3021481,23.8748175 20.2017778,23.8748175 L9.76740741,23.8748175 C9.66703704,23.8748175 9.58222222,23.7912409 9.58222222,23.6923358 L9.58222222,11.1354745 L20.386963,11.1354745 L20.386963,23.6923358 Z M21.8507407,10.0405839 L8.11851852,10.0405839 L8.11851852,8.73328467 L21.8507407,8.73328467 L21.8507407,10.0405839 Z M11.7328889,22.3270073 C11.426,22.3270073 11.1773333,22.0818978 11.1773333,21.779562 L11.1773333,13.4284672 C11.1773333,13.1261314 11.426,12.8810219 11.7328889,12.8810219 C12.0397037,12.8810219 12.2884444,13.1261314 12.2884444,13.4284672 L12.2884444,21.779562 C12.2884444,22.0818978 12.0397037,22.3270073 11.7328889,22.3270073 Z M14.9846667,22.3270073 C14.6778519,22.3270073 14.4291111,22.0818978 14.4291111,21.779562 L14.4291111,13.4284672 C14.4291111,13.1261314 14.6777778,12.8810219 14.9846667,12.8810219 C15.2915556,12.8810219 15.5402222,13.1261314 15.5402222,13.4284672 L15.5402222,21.779562 C15.5402222,22.0818978 15.2915556,22.3270073 14.9846667,22.3270073 Z M18.2363704,22.3270073 C17.9294815,22.3270073 17.6808148,22.0818978 17.6808148,21.779562 L17.6808148,13.4284672 C17.6808148,13.1261314 17.9294815,12.8810219 18.2363704,12.8810219 C18.5432593,12.8810219 18.7919259,13.1261314 18.7919259,13.4284672 L18.7919259,21.779562 C18.7919259,22.0818978 18.5432593,22.3270073 18.2363704,22.3270073 Z"
                    id="path-1"
                  />
                </svg>

                <svg
                  @click="
                    $router.push({
                      name: 'system-admin-company-accounts',
                      params: {
                        id: company.companyId,
                        title: company.companyName,
                      },
                    })
                  "
                  class="svg-grey accounts"
                  width="30px"
                  height="30px"
                  viewBox="0 0 30 30"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <title>Accounts</title>
                  <path
                    d="M19.3070588,15.3745636 L18.5167157,15.3745636 C20.0434804,14.3694763 21.0561275,12.6217456 21.0561275,10.6378055 C21.0561275,7.52907731 18.5704412,5 15.515049,5 C12.4596569,5 9.97397059,7.52907731 9.97397059,10.6378055 C9.97397059,12.6217456 10.9865196,14.3694763 12.5133824,15.3745636 L11.7230392,15.3745636 C9.69196078,15.3745636 8.03955882,17.0557107 8.03955882,19.1222444 L8.03955882,24.3573067 C8.03955882,24.7016459 8.31392157,24.9807481 8.65230392,24.9807481 L22.3777941,24.9807481 C22.7161765,24.9807481 22.9905392,24.7016459 22.9905392,24.3573067 L22.9905392,19.1221945 C22.9905392,17.0557107 21.3381373,15.3745636 19.3070588,15.3745636 Z M11.1994608,10.6378055 C11.1994608,8.21665835 13.1353922,6.24688279 15.515049,6.24688279 C17.8946569,6.24688279 19.8306373,8.21665835 19.8306373,10.6378055 C19.8306373,13.0589027 17.8946569,15.0286284 15.515049,15.0286284 C13.1353922,15.0286284 11.1994608,13.0589027 11.1994608,10.6378055 Z M17.3078431,15.9724688 L15.515049,17.7966085 L13.7222549,15.9725187 C14.2848529,16.1687781 14.8878922,16.2755112 15.515049,16.2755112 C16.1422059,16.2755112 16.7452941,16.1687781 17.3078431,15.9724688 Z M21.765049,23.7338155 L20.0983824,23.7338155 L20.0983824,20.7383541 C20.0983824,20.394015 19.8240196,20.1149127 19.4856373,20.1149127 C19.1472549,20.1149127 18.8728922,20.394015 18.8728922,20.7383541 L18.8728922,23.7338155 L12.1572059,23.7338155 L12.1572059,20.7383541 C12.1572059,20.394015 11.8828431,20.1149127 11.5444608,20.1149127 C11.2060784,20.1149127 10.9317157,20.394015 10.9317157,20.7383541 L10.9317157,23.7338155 L9.26504902,23.7338155 L9.26504902,19.1221945 C9.26504902,17.7432918 10.3676961,16.6213965 11.7230392,16.6213965 L12.6269118,16.6213965 L15.0817647,19.1190524 C15.2014216,19.240798 15.3582353,19.3016459 15.515049,19.3016459 C15.6718627,19.3016459 15.8285784,19.240798 15.9483333,19.1190524 L18.4031863,16.6213965 L19.3070588,16.6213965 C20.6623529,16.6213965 21.765049,17.743192 21.765049,19.1221945 L21.765049,23.7338155 Z"
                    id="path-1"
                  />
                </svg>
                <svg
                  @click="
                    $router.push({
                      name: 'system-admin-companies-transaction-history',
                      params: {
                        id: company.companyId,
                        company_name: company.companyName,
                      },
                    })
                  "
                  version="1.1"
                  class="svg-grey"
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  width="24px"
                  height="30px"
                  viewBox="0 0 456.795 456.795"
                  xml:space="preserve"
                >
                  <title>Transaction History</title>
                  <g>
                    <g>
                      <path
                        d="M448.947,218.475c-0.922-1.168-23.055-28.933-61-56.81c-50.705-37.253-105.877-56.944-159.551-56.944
			c-53.672,0-108.844,19.691-159.551,56.944c-37.944,27.876-60.077,55.642-61,56.81L0,228.397l7.846,9.923
			c0.923,1.168,23.056,28.934,61,56.811c50.707,37.252,105.879,56.943,159.551,56.943c53.673,0,108.845-19.691,159.55-56.943
			c37.945-27.877,60.078-55.643,61-56.811l7.848-9.923L448.947,218.475z M228.396,315.039c-47.774,0-86.642-38.867-86.642-86.642
			c0-7.485,0.954-14.751,2.747-21.684l-19.781-3.329c-1.938,8.025-2.966,16.401-2.966,25.013c0,30.86,13.182,58.696,34.204,78.187
			c-27.061-9.996-50.072-24.023-67.439-36.709c-21.516-15.715-37.641-31.609-46.834-41.478c9.197-9.872,25.32-25.764,46.834-41.478
			c17.367-12.686,40.379-26.713,67.439-36.71l13.27,14.958c15.498-14.512,36.312-23.412,59.168-23.412
			c47.774,0,86.641,38.867,86.641,86.642C315.037,276.172,276.17,315.039,228.396,315.039z M368.273,269.875
			c-17.369,12.686-40.379,26.713-67.439,36.709c21.021-19.49,34.203-47.326,34.203-78.188s-13.182-58.697-34.203-78.188
			c27.061,9.997,50.07,24.024,67.439,36.71c21.516,15.715,37.641,31.609,46.834,41.477
			C405.91,238.269,389.787,254.162,368.273,269.875z"
                      />
                      <path
                        d="M173.261,211.555c-1.626,5.329-2.507,10.982-2.507,16.843c0,31.834,25.807,57.642,57.642,57.642
			c31.834,0,57.641-25.807,57.641-57.642s-25.807-57.642-57.641-57.642c-15.506,0-29.571,6.134-39.932,16.094l28.432,32.048
			L173.261,211.555z"
                      />
                    </g>
                  </g>
                </svg>
                <svg
                  @click="
                    $router.push({
                      name: 'system-admin-companies-invoice-history',
                      params: {
                        id: company.companyId,
                        title: company.companyName,
                      },
                    })
                  "
                  class="svg-grey"
                  width="30px"
                  height="30px"
                  viewBox="0 0 30 30"
                  version="1.1"
                >
                  <title>Invoice History</title>
                  <path
                    d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
                    id="path-1"
                  />
                </svg>
                <svg
                  @click="
                    $router.push({
                      name: 'system-admin-companies-payment-history',
                      params: {
                        id: company.companyId,
                        title: company.companyName,
                      },
                    })
                  "
                  id="Capa_1"
                  class="svg-grey"
                  enable-background="new 0 0 511.969 511.969"
                  height="30px"
                  viewBox="0 0 511.969 511.969"
                  width="24px"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>Payment History</title>

                  <g id="XMLID_1487_">
                    <g id="XMLID_1153_">
                      <path
                        id="XMLID_1329_"
                        d="m426.523 283.917-76.444-119.836c10.831-5.692 18.24-17.05 18.24-30.112 0-14.297-8.875-26.553-21.402-31.57l23.158-80.964c.999-3.493.025-7.252-2.543-9.821-15.405-15.404-40.469-15.404-55.874 0-3.685 3.685-8.584 5.714-13.795 5.714s-10.11-2.029-13.818-5.738l-.049-.049c-15.35-15.352-40.371-15.395-55.783-.091l-.287.286c-7.607 7.553-19.962 7.531-27.541-.049l-.073-.073c-15.405-15.404-40.469-15.404-55.874 0-2.57 2.571-3.543 6.333-2.542 9.828l23.208 80.938c-12.554 5.004-21.453 17.273-21.453 31.59 0 13.062 7.408 24.42 18.24 30.112l-76.445 119.835c-29.574 46.36-31.448 102.826-5.013 151.045s75.047 77.007 130.038 77.007h91.026c54.99 0 103.602-28.788 130.038-77.007 26.435-48.219 24.562-104.685-5.012-151.045zm-240.354-258.161.073.073c15.352 15.351 40.372 15.393 55.783.091l.287-.286c7.606-7.553 19.961-7.531 27.564.072l.049.049c15.405 15.404 40.469 15.404 55.874 0 6.268-6.268 15.775-7.371 23.183-3.309l-22.172 77.523h-141.59l-22.23-77.524c7.408-4.061 16.912-2.956 23.179 3.311zm227.829 399.592c-22.87 41.716-64.926 66.622-112.5 66.622h-91.026c-47.574 0-89.63-24.905-112.5-66.622-22.87-41.716-21.249-90.566 4.336-130.675l80.825-126.704h27.852c5.523 0 10-4.477 10-10s-4.477-10-10-10h-33.334c-7.72 0-14-6.28-14-14s6.28-14 14-14h.033 156.634c7.72 0 14 6.28 14 14s-6.28 14-14 14h-33.333c-5.523 0-10 4.477-10 10s4.477 10 10 10h27.851l80.826 126.704c25.585 40.108 27.206 88.958 4.336 130.675z"
                      />
                      <path
                        id="XMLID_1341_"
                        d="m273.615 326.579c-2.509-.887-5.07-1.81-7.63-2.769v-45.322c6.78 1.995 11.308 5.23 11.5 5.37 4.399 3.295 10.64 2.421 13.964-1.966 3.335-4.402 2.47-10.674-1.932-14.01-.587-.445-9.885-7.347-23.532-9.96v-9.952c0-5.523-4.477-10-10-10s-10 4.477-10 10v9.88c-1.694.325-3.411.736-5.151 1.259-14.074 4.229-24.594 16.265-27.455 31.411-2.611 13.83 1.82 27.169 11.564 34.811 5.288 4.147 11.895 7.934 21.042 11.956v57.996c-7.875-.498-13.143-2.29-21.925-8.035-4.621-3.025-10.82-1.728-13.843 2.894-3.024 4.622-1.728 10.819 2.894 13.843 12.806 8.377 21.477 10.75 32.874 11.311v10.341c0 5.523 4.477 10 10 10s10-4.477 10-10v-11.38c21.414-4.69 33.938-22.559 36.748-39.275 3.673-21.854-7.756-40.853-29.118-48.403zm-36.329-16.986c-3.844-3.015-5.474-8.902-4.254-15.363 1.122-5.942 5.12-13.107 12.953-15.758v36.623c-3.288-1.753-6.255-3.585-8.699-5.502zm45.723 62.072c-1.44 8.565-7.221 17.649-17.025 21.663v-48.239c.326.116.635.229.965.346 17.929 6.337 16.826 21.679 16.06 26.23z"
                      />
                      <path
                        id="XMLID_1343_"
                        d="m255.985 167.969c2.63 0 5.21-1.07 7.07-2.93s2.93-4.44 2.93-7.07-1.07-5.21-2.93-7.07-4.44-2.93-7.07-2.93-5.21 1.07-7.07 2.93-2.93 4.44-2.93 7.07 1.07 5.21 2.93 7.07 4.439 2.93 7.07 2.93z"
                      />
                    </g>
                  </g>
                </svg>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="per-page">
        <span class="filter_by custom-row mr-2">Show Per Page:</span>
        <div class="primary-input-container choose-type perPage">
          <primary-select
            type="text"
            @input="changePerPage"
            v-model="per_page" :is-cross="false"
            class="choose-type perPage"
            placeholder="Select"
          >
            <option :value="item" v-for="(item, key) in pages" :key="key">
              {{ item }}
            </option>
          </primary-select>
        </div>
      </div>
      <div v-if="!isFound" class="buttons-wrapper">
        <pagination-component
          @change-page="changePage($event)"
          :page="Page"
          :total="TotalPages"
          :perPage="per_page"
          :qnt="allcompanies.length"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    Loader: () => import("@/components/Loader.vue"),
    NotFound: () => import("@/components/NotFound.vue"),
  },
  data: () => ({
    showDropDown: false,
    paymentTypes: [
      { name: "All", value: "" },
      { name: "Prepaid", value: true },
      { name: "Postpaid", value: false },
    ],
    prepay: "",
    companies: [],
    resellers: [],
    selectedCompany: "",
    selectedReseller: "",
    allcompanies: [],
    ownCompanies: [],
    companyName: "",
    isActive: false,
    Page: 0,
    SearchCompany: "",
    TotalPages: null,
    filter: "",
    reseller: "",
    pages: [10, 50, 100],
    per_page: 10,
    loading: true,
    isFound: false,
    isActive: true,
  }),
  watch: {
    SearchCompany: function () {
      this.getAllCompanies(this.SearchCompany, 0, "company");
    },
    filter: function () {
      this.getResellersList();
    },
    reseller: function () {
      this.getAllCompanies(this.reseller + "*", 0, "reseller");
    },
    isActive() {
      this.Page = 0;
      this.getAllCompanies();
    },
    selectedCompany(company) {
      this.getAllCompanies();
    },
    selectedReseller(reseller) {
      this.getAllCompanies();
    },
    prepay(isPrepay) {
      this.getAllCompanies();
    },
  },
  created() {
    this.getCompanyList();
    this.getAllCompanies(this.Searched, this.Page);
    this.getResellersList();
  },
  methods: {
    reasetFilters() {
      this.SearchCompany = "";
      this.filter = "";
      this.reseller = "";
      this.getAllCompanies();
    },
    changePerPage(e) {
      this.Page = 0;
      this.getAllCompanies();
    },
    changeStatus(company) {
      this.$store
        .dispatch("EditCompanyInfo", {
          companyInfo: { is_active: company.isActive ? false : true },
          id: company.companyId,
        })
        .then((res) => {
          this.$snotify.success("Company status has changed", {
            timeout: 6000,
          });
          this.getAllCompanies();
        });
    },
    changePage(page) {
      this.Page = page;
      this.getAllCompanies(this.Searched, this.Page);
    },
    getCompanyList() {
      this.$store.dispatch("GetCompanyList", {}).then((res) => {
        const { total } = res;

        this.$store
          .dispatch("GetCompanyList", { perPage: total, page: 0 })
          .then((_res) => {
            this.companies = _res.items.map(this.transformCompany);
          });
      });
    },
    getAllCompanies(search, page = this.Page, from) {
      this.loading = true;
      this.isFound = false;
      this.$store
        .dispatch("GetCompanyList", {
          is_active: this.isActive,
          page: page,
          per_page: this.per_page ? this.per_page : 10,
          company_name: from == "company" ? search : "",
          reseller: from == "reseller" ? search : "",
          prepay: this.prepay === "all" ? "" : this.prepay,
          company_uuid: this.selectedCompany || "",
          reseller_uuid: this.selectedReseller || "",
        })
        .then((res) => {
          this.loading = false;
          if (!res.items.length) {
            this.isFound = true;
            return;
          }
          this.Page = res.page;
          this.TotalPages = res.total / res.per_page;
          this.allcompanies = res.items.map(this.transformCompanies);
        });
    },
    getResellersList() {
      this.$store
        .dispatch("GetResellerList", {
          page: 0,
          search: "",
          perPage: 1000,
        })
        .then((res) => {
          this.resellers = res.items.map(this.transformReseller);
        });
    },
    transformCompany(company) {
      return {
        name: company.company_name,
        value: company.company_uuid,
      };
    },
    transformReseller(reseller) {
      return {
        name: reseller.reseller_name,
        value: reseller.reseller_uuid,
      };
    },
    transformCompanies(i, k) {
      return {
        companyName: i.company_name,
        email: i.contact && i.contact.email,
        balance: i.balance,
        prepay: !i.prepay,
        contactPerson: i.contact && i.contact.full_name,
        resaller: i.reseller_name,
        companyId: i.company_uuid,
        isActive: i.is_active,
        status: i.status,
        credit: i.credit,
        created_on: format(i.created_on, "YYYY:MM:DD HH:mm:ss"),
        logoId: i.contact && i.contact.logo_file_uuid,
        productName: i.product_name,
      };
    },
    deleteCompany(companyId) {
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this company!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("DeleteCompany", companyId)
            .then((res) => {
              this.getAllCompanies();
              this.$swal(
                "Deleted!",
                "Your company has been deleted.",
                "success"
              );
            })
            .catch((err) => {
              this.$snotify.error(err.response.statusText);
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.product-container {
  padding: 0 20px;

  .show-active-items {
    display: flex;
    align-items: center;

    .active-checkbox {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
    label {
      width: 90px;
      margin-bottom: 0;
    }
  }
  .per-page {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  .perPage {
    width: 120px;
    margin-right: 15px;
  }
}
table.Invoice_table {
  width: 100%;
  margin-top: 21px;

  th {
    text-align: center;

    &.company-name {
      width: 250px !important;
    }
    &.postpay {
      width: 145px;
    }
    &.created-on {
      width: 175px;
    }
    &.email {
      width: 250px;
    }
    div {
      text-align: center;
    }
  }
  tbody {
    th.created-on,
    th.email,
    th.reseller {
      padding-left: 0;
      padding-right: 0;
    }
  }
}
table.Invoice_table thead {
  tr {
    background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);

    th {
      color: #fff;
    }
    th:first-child {
      padding-left: 20px;
      padding-right: 30px;
      // width: 14%;
    }
  }
}
table,
tr {
  width: 100%;
  height: 44px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
table tr th {
  padding: 7px 10px 7px 20px;
}
table {
  border-collapse: collapse;
}
.Invoice_table_header th {
  color: white;
  padding-left: 10px;
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
  text-align: center;
}
.speace {
  width: 15px;
}
.popup_content {
  display: none;
}
.popup_cta {
  cursor: pointer;
}
.btn-link {
  bottom: 10px;
  color: black;
}
.dropdown-menu {
  width: 228px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.1);
  a {
    padding: 10px 15px;
    font-family: "Helvetica Neue";
    font-size: 16px;
    line-height: 20px;
  }
  a:hover {
    color: #51a3f3;
    height: 40px;
    background-color: #f8f9fe;
  }
}
.Invoice_table_popup {
  height: 30px;
  text-align: right;
  position: relative;
  padding: 0;
  float: right;
  .popup_cta {
    cursor: pointer;
    color: #55616e;
  }
}
tbody th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  height: 20px;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  padding: 7px 10px 7px 0;
  text-align: left;
}
table thead th:first-child {
  padding-left: 35px;
}
tbody th:first-child {
  padding: 5px 10px 5px 0;
  span {
    padding: 7px 0;
  }
}
tbody th.created_by {
  line-height: 20px;
  height: 20px;
  padding: 7px 0 27px 0;
}
.Invoice_price {
  font-family: "Helvetica Neue";
  padding: 13px 0 12px 0;
  color: #000000;
  font-weight: bold;
}
.Invoice_table_popup.active .popup_content {
  display: block;
  right: 0;
  width: 240px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.1);
  padding-left: 0;
  list-style-type: none;
  text-align: left;
}
.Invoice_table_popup.active .popup_content a {
  color: #55616e;
  font-size: 16px;
  line-height: 20px;
  text-decoration: none;
  font-family: "Helvetica Neue";
  padding: 10px 15px;
  display: inline-block;
}
.popup_image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: middle;
  margin: 2px 8px 0px 0;
}

.img-container {
  display: flex;
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 228px;
    text-align: start;
  }
}
th.user_active:after {
  content: "";
  height: 10px;
  width: 10px;
  background-color: #24e2b8;
  position: absolute;
  border-radius: 50%;
  left: 12px;
  top: 17px;
  // margin: 17px 0 37px 12px;
}

th.user_active {
  text-align: left;
  position: relative;
  padding: 7px 0 7px 0;
}
th.smsText {
  color: #55616e;
  font-family: "Helvetica Neue";
  font-size: 14px;
  font-weight: normal;
  line-height: 25px;
  padding: 10px 0 10px 0;
}
th.status {
  padding: 10px 18px 10px 0;
  .approved {
    box-sizing: border-box;
    height: 24px;
    width: 80px;
    border: 2px solid #ffffff;
    border-radius: 100px;
    background-color: #24e2b8;
    color: #ffffff;
    font-family: "Helvetica Neue";
    font-size: 13px;
    font-weight: normal;
    line-height: 16px;
    padding: 4px 10px;
  }
  .rejected {
    box-sizing: border-box;
    height: 24px;
    width: 74px;
    border: 2px solid #ffffff;
    border-radius: 100px;
    background-color: #d2305b;
    color: #ffffff;
    font-family: "Helvetica Neue";
    font-size: 13px;
    font-weight: normal;
    line-height: 16px;
    padding: 4px 10px;
  }
}
th.icon {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: fit-content;

  .primary {
    // padding-top: 11px;
    width: 90px;
    height: 30px;
    font-size: 12px;
    line-height: 20px;
    border-radius: 100px;
    margin-right: 10px;
  }
  .primary.active {
    border: 2px solid #ffffff;
    border-radius: 100px;
    background-color: #24e2b8;
    color: #ffffff;
    // opacity: 0.68;
  }
  .svg-grey {
    fill: #55616e;
    margin-left: 3px;
  }
  .message {
    margin-right: 10px;
  }

  .delete {
    margin-right: 0px;
  }
  .radio-button {
    height: 30px;
    width: 50px;
    border-radius: 15px;
    background-color: #ffffff;
    border: 1px solid #a6b6be;
    margin-left: 10px;
    padding: 1px 23px 3px 3px;
    cursor: pointer;
    svg {
      height: 24px;
      width: 24px;
      // box-shadow: 2px 2px 7px 0 rgba(77,84,94,0.24);
    }
  }
  .radio-button.active {
    padding: 2px 3px 3px 23px;
    background-color: #24e2b8;
    border: 0;
  }
}
th.reseller {
  width: 180px;
  line-height: 25px;
  font-family: "Helvetica Neue";
  color: #000000;
}
.Invoice_table_sub_header th {
  height: 30px;
  color: #bdbfd8;
  font-family: "Helvetica Neue";
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 1px;
  line-height: 30px;
  padding: 5px 0 5px 15px;
}
th.allcompanies {
  padding-top: 20px;
}
.status {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-grid;
  margin: 12px 12px 0 13px;
}

.active {
  th .status {
    background-color: #24e2b8;
  }
}
.inactive {
  // background-color: #f0f1fa;
  th .status {
    background-color: #d2305b;
  }
}
@media (max-width: 1820px) {
  table.Invoice_table {
    width: 1720px;
  }
}
@media screen and (max-width: 1570px) {
  .product-container .add-navigation .buttons-wrapper {
    width: 100%;
  }
}
.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}
.input-min-width{
  min-width: 200px!important;
 margin-top: 15px!important;
}
@media (max-width: 464px) {
  .primary-button{
    width: 200px!important;
  }
}

</style>

